import Modal from "@/components/modal/modal.vue";

export default { components: { Modal } };
